import { Link } from "react-router-dom";
import { buttonVariants } from "@/components/ui/button";
import { ROUTES } from "@/lib/navigation";
import { cn } from "@/lib/utils";

interface AuthButtonsProps {
  /** `row`: fejléc (regisztráció a kiemelt), `stack`: mobil menü lábléce (bejelentkezés a kiemelt) */
  layout?: "row" | "stack";
  /** A fejléc pill-nyelvéhez igazodva teljesen lekerekítve (csak a sávban) */
  pill?: boolean;
  onNavigate?: () => void;
  className?: string;
}

/**
 * Gombnak kinéző linkek. Nem `Button render={<Link />}`: a Base UI Button gomb-szemantikát
 * kényszerít (role, billentyűkezelés) és fejlesztői hibát ír, ha nem gombot renderel –
 * egy link maradjon link, csak a `buttonVariants` osztályait kapja.
 */
export function AuthButtons({ layout = "row", pill = false, onNavigate, className }: AuthButtonsProps) {
  const stacked = layout === "stack";
  const shape = pill && "rounded-full";
  return (
    <div className={cn("flex gap-2", stacked ? "flex-col" : "items-center", className)}>
      <Link
        to={ROUTES.login}
        onClick={onNavigate}
        className={cn(buttonVariants({ variant: stacked ? "default" : "ghost" }), shape)}
      >
        Bejelentkezés
      </Link>
      <Link
        to={ROUTES.register}
        onClick={onNavigate}
        className={cn(buttonVariants({ variant: stacked ? "outline" : "default" }), shape)}
      >
        Regisztráció
      </Link>
    </div>
  );
}
